import React from 'react';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';

function CalendarItem({
  day,
  disabled,
  selectedDay,
  onCalendarItemClick,
}) {
  const getItemStyle = () => {
    if (disabled) {
      return 'border-gray text-gray';
    } else if (selectedDay === day) {
      return 'bg-primary text-white hover:bg-primaryDark cursor-pointer';
    }
    return 'text-primary border-primary hover:text-white hover:bg-primary cursor-pointer';
  };

  const lang = useSelector(langSelector);
  return (
    <div
      className={`border-2 ${getItemStyle()} rounded-[20px] flex justify-center items-center text-3xl font-medium h-[70px] w-[70px]`}
      style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}
      onClick={onCalendarItemClick}
    >
      {day}
    </div>
  );
}

export default function Calendar({
  numberOfDays,
  disabledList,
  selectedDay,
  setSelectedDay,
  isHidden,
  isError,
  error
}) {
  const generateRange = (n) => {
    const result = [];
    for (let i = 1; i <= n; i++) {
      result.push(i);
    }
    return result;
  };

  const numberExistsInList = (number, list) => {
    return list.includes(number);
  };

  return (
    <div className={`w-[400px] ${isError && 'border-2 border-primary rounded-[20px]'} ${isHidden ? 'hidden' : 'inline'}`}>
      <div className='grid grid-cols-5 gap-2 w-[400px]'>
        {generateRange(numberOfDays).map((n) => {
          return (
            <CalendarItem
              key={n}
              day={n}
              disabled={numberExistsInList(n, disabledList)}
              selectedDay={selectedDay}
              onCalendarItemClick={() => {
                if (!numberExistsInList(n, disabledList)) {
                  setSelectedDay(n);
                }
              }}
            />
          );
        })}
      </div>
      <p className={`relative pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`}>{error}</p>
    </div>
  );
}
